var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-title',{attrs:{"title":"Pathway Plan dashboard"}}),(_vm.currentUser.userType === 'YP')?_c('pathway-plan'):_c('sw-pp-dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }